import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/auth')({
  notFoundComponent: () => <Navigate to="/auth/login" replace />,
  component: Outlet,
});
